import {FC, Fragment, useCallback} from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {useNavigate} from "react-router-dom";
import {useStore} from "modules/hooks";
import {CloseButton, LogoWrapper} from "components";
import {Modal, Overlay} from "components/Modal";
import {ReactComponent as Logo} from "assets/images/modal-logo.svg";
import {ReactComponent as CloseIcon} from "assets/images/icons/close.svg";

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const Content = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 24px;
	align-items: center;
	padding: 24px 16px;
	max-width: 360px;
`;

const Title = styled.div`
	font-size: 14px;
	line-height: 130%;
	letter-spacing: 0.84px;
	text-align: center;
	color: #d90f1b;
	text-transform: uppercase;
`;

const Desc = styled.div`
	font-size: 12px;
	line-height: 160%;
	padding: 0 16px;
	text-align: center;
`;

export const NotFoundModal: FC = observer(() => {
	const {I18n} = useStore();
	const navigate = useNavigate();

	const handleClose = useCallback(() => {
		navigate("/");
	}, [navigate]);

	return (
		<Fragment>
			<Overlay onClick={handleClose} />
			<Modal>
				<Container>
					<CloseButton onClick={handleClose}>
						<CloseIcon />
					</CloseButton>

					<LogoWrapper>
						<Logo />
					</LogoWrapper>

					<Content>
						<Title>{I18n.t("modal.not_found.title")}</Title>
						<Desc>{I18n.t("modal.not_found.desc")}</Desc>
					</Content>
				</Container>
			</Modal>
		</Fragment>
	);
});
